import { SidebarMenuItem, SidebarMenuItemProps } from 'framework/ui/menu';
import React from 'react';
import Workspaces from '@mui/icons-material/Workspaces';

const ClientPortalMenuItem = ({ linkUrl, ...props }: SidebarMenuItemProps) => (
  <SidebarMenuItem {...props} linkUrl={linkUrl} icon={<Workspaces />} />
);

ClientPortalMenuItem.displayName = 'Client Portal';

export default ClientPortalMenuItem;
